import { useSelector } from "react-redux";
import { ApplicationState } from "../store/store";
import { UserSessionState } from "../store/userSession/types";

export const useUserSession = (): UserSessionState => {
  return useSelector((state: ApplicationState) => state.userSession);
};
